import React from 'react';
import PropTypes from 'prop-types';
import { TimelineMaintenanceBase } from './TimelineMaintenance.styles';
import { MaintenanceChartRowHeader } from './MaintenanceChartRowHeader';
import { MaintenanceReleaseChartVictory } from './MaintenanceReleaseChartVictory';
import { WithScroller } from 'lib/components/Scroller/WithScroller';
import { useRematchSelector } from 'models/rematchStore';

export const MaintenanceReleaseChart = ({ chartWidth, theme }) => {
    const headerWidth = 500;
    const chartMinWidth = 1000;
    const chartMaxWidth = 2000;
    const useScroller = chartWidth <= chartMinWidth;
    const childChartWidth = useScroller ? chartMaxWidth : chartWidth;
    const { timelineData } = useRematchSelector((state) => state.parkMaintenance);

    return (
        <TimelineMaintenanceBase>
            <WithScroller useScroller={useScroller}>
                {() => (
                    <>
                        <MaintenanceChartRowHeader width={headerWidth} chartWidth={childChartWidth} />
                        <MaintenanceReleaseChartVictory
                            chartWidth={childChartWidth}
                            timelineData={timelineData}
                            itemLabelWidth={headerWidth}
                            theme={theme}
                        />
                    </>
                )}
            </WithScroller>
        </TimelineMaintenanceBase>
    );
};

MaintenanceReleaseChart.displayName = 'MaintenanceReleaseChart';

MaintenanceReleaseChart.propTypes = {
    chartWidth: PropTypes.number,
};

MaintenanceReleaseChart.defaultProps = {};
